import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { trabajos } from "../data/trabajos.js";

export const ProyectoComponent = () => {
  const { id } = useParams();
  const [proyecto, setProyecto] = useState(null);

  useEffect(() => {
    const encontrado = trabajos.find((trabajo) => trabajo.id === id);
    setProyecto(encontrado || null);
  }, [id]);

  if (!proyecto) {
    return (
      <div style={{ textAlign: "center", padding: "80px 20px" }}>
        <h1 style={{ color: "red", fontSize: "28px" }}>
          Proyecto no encontrado
        </h1>
        <p style={{ color: "#555", marginTop: "12px" }}>
          El proyecto solicitado no existe o el ID es inválido.
        </p>
      </div>
    );
  }

  const tieneVistas = proyecto.vistas && proyecto.vistas.length > 0;

  return (
    <div className="project-container">
      <h1 className="heading">{proyecto.nombre}</h1>

      <div className="project-header">
        <div className="project-info">
          <p>
            <strong>Tecnologías:</strong> {proyecto.tecnologias}
          </p>
          <p style={{ whiteSpace: "pre-line", marginTop: "12px" }}>
            <strong>Descripción:</strong> {proyecto.descripcion}
          </p>

          {proyecto.url && (
            <a
              href={proyecto.url}
              target="_blank"
              rel="noopener noreferrer"
              className="visit-button"
            >
              Visitar la página
            </a>
          )}
        </div>

        <div className="project-image-main">
          <img
            src={`/imagenes/${proyecto.id}.png`}
            alt={`Imagen del proyecto ${proyecto.nombre}`}
          />
        </div>
      </div>

      {tieneVistas && (
        <div className="vistas-section">
          <h2 className="heading" style={{ textAlign: "center", marginBottom: "32px" }}>
            Vistas del Proyecto
          </h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
            {proyecto.vistas.map((vista, index) => (
              <div
                key={index}
                className={`vista-item ${index % 2 !== 0 ? "reverse" : ""}`}
              >
                <div className="vista-image">
                  <img src={vista.image} alt={`Vista: ${vista.titulo}`} />
                </div>

                <div className="vista-text">
                  <h3>{vista.titulo}</h3>
                  <p>{vista.descripcion}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
